import Phaser from 'phaser';

export default class RadioButton extends Phaser.Group {
    constructor(game, parent, value, label, fontSize) {
        super(game, parent);

        this.value = value;
        this.label = label;
        this.fontSize = fontSize || 50;

        this.init();
    }

    init() {
        this.button = this.game.add.sprite(0, 0, "sheet", "radio-button");
        this.button.anchor.set(0.5);
        this.add(this.button);

        let label = this.game.add.bitmapText(40, 0, "font-title", this.label, this.fontSize);
        label.align = "center";
        label.anchor.set(0, 0.5);
        this.add(label);

        this.bullet = this.game.add.bitmapText(0, -30, "font-title", ".", 150);
        this.bullet.align = "center";
        this.bullet.anchor.set(0.5);
        this.add(this.bullet);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/objects/ui/RadioButton.js
// module id = 144
// module chunks = 0